<template>
  <v-container fluid>
    <div>
      <create-time-slot
        v-if="showForm"
        @success="getTimeSlotsList"
        @closed="showForm = false"
      />
    </div>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-calendar-clock
      </v-icon>   Time Slots
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createTimeSlot()"
        >
          Create New
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="timeSlots"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>
              {{ item.duration }}
            </td>
            <td>{{ item.created_at | convertStringToLocalDatetime }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="red"
                @click.stop
                @click="deleteTimeSlot()"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  import CreateTimeSlot from './CreateTimeSlot.vue';

  export default {
    name: 'TimeSlots',
    components: {
      'centre-spinner': spinner,
      'create-time-slot': CreateTimeSlot,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Duration', value: 'duration' },
          { text: 'Created At', value: 'created_at' },
          { text: 'Delete', value: 'delete' },
        ],
        showForm: false,
      };
    },
    computed: {
      timeSlots () {
        return this.$store.getters['digiboards/getTimeSlotsList'];
      },
    },
    async mounted () {
      await this.getTimeSlotsList();
    },
    methods: {
      async getTimeSlotsList () {
        this.loading = true;
        await this.$store.dispatch('digiboards/fetchTimeSlotsList');
        this.loading = false;
      },
      deleteTimeSlot () {
        this.$store.dispatch('alert/onAlert', {
          message: 'Sorry you are not authorized to delete any time slots from the list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
      createTimeSlot () {
        this.showForm = true;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table {
  background-color: #ECEFF1;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
</style>
